import React from 'react';

import Flex from '../styled/Flex';
import { convertToMax } from '../../utils';

const IdField = ({ rowIndex, stats, pageSize, value }) => {
	const currentPage = (stats.currentPage || 0) + 1;
	return (
		<Flex wrap="nowrap" style={{ width: '100%' }} alignItems="center">
			<div>
				{convertToMax(
					pageSize * (currentPage - 1) + (rowIndex + 1),
					pageSize * (currentPage - 1) + pageSize,
				)}
			</div>
			<Flex
				wrap="nowrap"
				alignItems="center"
				style={{
					marginLeft: '10px',
				}}
			>
				{value}
			</Flex>
		</Flex>
	);
};

export default IdField;
